export const environment = {
  production: true,
  apiUrl: '',
  mapTilesUrl: '/tiles/switzerland.pmtiles',
};
